import {
    ENTITY_SERVICE_REGISTRY,
    EntityServiceEntry
} from 'features/core/shared/dto/dto-service/entity-service-registry';
import {MvsCrudModeEnum} from 'features/core/shared/service/crud/mvs-crud-mode.enum';
import {PdPartnerService} from './service/api/pd-partner.service';
import {
    PdPartnerObjectComponent
} from './component/object-components/pd-partner-object-component/pd-partner-object.component';

/**
 * Entity-service registry of the pd module.
 *
 * pd.PdPartner opens in PdPartnerObjectComponent when an existing partner is shown (update mode). Create mode
 * is deliberately NOT mapped: a new partner is captured in the generic metadata form.
 *
 * Collection runs, export runs and contract events are read-only and need nothing beyond the generic CRUD read,
 * so they are registered route-only (no service file, fe_core_mvs-crud-service SC6/SC7) and open in the generic
 * object view.
 */
export const PD_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['pd.PdPartner', {
                route: '/pd/pdPartners',
                service: PdPartnerService,
                objectComponent: [{mode: MvsCrudModeEnum.update, component: PdPartnerObjectComponent}]
            }],
            ['pd.PdPartnerCollectionRun', {route: '/pd/pdPartnerCollectionRuns'}],
            ['pd.PdPartnerExportRun', {route: '/pd/pdPartnerExportRuns'}],
            ['pd.PdPartnerContractEvent', {route: '/pd/pdPartnerContractEvents'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
